import { useContext } from 'react';
import { FileBrowserContext } from './FileBrowserProvider';
export const useFileBrowserContext = () => useContext(FileBrowserContext);
